import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromShifts from './shifts.reducer';

export const selectShifts = createFeatureSelector<fromShifts.IShiftsState>('shifts');
export const selectAllShifts = createSelector(selectShifts, fromShifts.selectAllShifts);
export const selectedShiftId = createSelector(selectShifts, (v) => v.selectShiftId);
export const selectedShift = createSelector(selectShifts, selectedShiftId, (stationDb, selectedId) => {
  return selectedId ? stationDb.entities[selectedId] : undefined;
});
export const selectIsWithinWorkingHours = createSelector(selectShifts, (v) =>
  v.isWithinWorkingHours !== null ? v.isWithinWorkingHours : true,
);
export const selectSessionTimes = createSelector(selectShifts, (state) =>
  state.sessionTimes ? state.sessionTimes : { start_time: '', end_time: '' },
);
